export default __webpack_public_path__ + "static/media/patient-1.e18c2bb0.jpg";